module.exports = __webpack_public_path__ + "img/index4.62b8d3c9.png";